var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-text',[_c('PageHeader'),_c('div',{staticClass:"container"},[_c('Coupons'),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-sm-9"},[_c('ProductList')],1),_c('div',{staticClass:"col-sm-3"},[_c('ShoppingCart')],1)])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }